module.exports = __webpack_public_path__ + "img/fly_baghdad.826f18a2.png";